import { FastField, FieldProps } from 'formik';
import { memo } from 'react';
import { View } from 'react-native';

import { FormControlTextInput } from '@fhs/ui';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { CHECKOUT_DELIVERY_INSTRUCTIONS_INPUT } from '@fhs-legacy/frontend/src/utils/test-ids';

function DeliveryInstructionsField() {
  const { setDeliveryInstructions } = useOrderContext();

  return (
    <FastField name="deliveryInstructions">
      {({ field, meta }: FieldProps) => {
        const handleBlur = (e: any) => {
          field.onBlur('deliveryInstructions')(e);
          setDeliveryInstructions(field.value);
        };

        const hasError = meta.touched && meta.error;

        return (
          <View style={{ marginVertical: 13 }}>
            <FormControlTextInput
              testID={CHECKOUT_DELIVERY_INSTRUCTIONS_INPUT}
              label="Delivery Instructions"
              placeholder="Enter delivery instructions"
              value={field.value}
              onChangeText={field.onChange('deliveryInstructions')}
              onBlur={handleBlur}
              error={hasError ? meta.error : undefined}
              multiline
              numberOfLines={4}
              maxLength={512}
              textAlignVertical="top"
              inputContainerStyle={{ alignItems: 'flex-start', paddingVertical: 12 }}
              style={{ paddingVertical: 6 }}
            />
          </View>
        );
      }}
    </FastField>
  );
}

export default memo(DeliveryInstructionsField);
